<template>
  <div class="editor">
    <textarea :id="id"/>
  </div>
</template>

<script>
import { requestAnimFrame } from '@/utils'
import { upload } from '@/utils/request'

let id = 0
export default {
  model: { prop: 'value', event: 'change' },
  props: {
    value: { type: String, default: '' },
    // 编辑器初始高度值
    minHeight: { type: Number, default: 500}
  },
  data() {
    return {
      id: 'editor_' + (id++),
      $editor: null,
      toolbar: [
        'undo redo alignleft aligncenter alignright alignjustify bullist numlist table image link hr fullscreen',
        'bold italic underline strikethrough forecolor backcolor formatselect fontsizeselect',
      ]
    }
  },
  methods: {
    // 富文本中的图片开始上传
    imagesUpload() {
      return new Promise(resolve => {
        resolve(this.$editor.uploadImages())
      }).then(() => {
        this.$emit('change', this.$editor.getContent())
      })
    },
    // 更新内容
    updateContent(n) {
      this.$editor.setContent(n)
    }
  },
  mounted() {
    const tinymce = window.tinymce
    const baseURL = process.env.NODE_ENV==='development'?'':'/poros-community'
    this.$nextTick(() => {
      tinymce && tinymce.init({
        selector: '#' + this.id,
        min_height: this.minHeight,
        max_height: 600,
        max_width: '100%',
        language:'zh_CN', //调用放在langs文件夹内的语言包
        menubar: false, //隐藏菜单栏
        plugins : 'advlist image link table lists autoresize textcolor fullscreen hr', //字符串方式
        toolbar: this.toolbar,
        statusbar: false, // 隐藏状态栏
        setup: (editor) => {
          editor.on('blur', () => {
            this.$emit('change', editor.getContent())
          })
          editor.on('input', () => {
            this.$emit('change', editor.getContent())
          })
          // 监听剪贴板事件，上传图片
          editor.on('paste', () => {
            requestAnimFrame(this.imagesUpload)
          })
          editor.on('load', () => {
            this.$nextTick(() => editor.setContent(this.value))
            this.$emit('load')
          })
          this.$editor = editor
        },
        // automatic_uploads: false,
        images_upload_handler: (blobInfo, succFun, failFun) => {
          console.log('===========')
          const uploadAjax = (blobInfo) => {
            return new Promise((resolve, reject) => {
              const blob = blobInfo.blob(),
                isFile = blob.constructor === File, // 是否选择的文件
                file = isFile ? blob : blobInfo.base64() // 不是文件，则转成base64
              upload(file, {
                base64: !isFile,
                onSuccess: resolve,
                onError: reject
              })
            })
          }
          uploadAjax(blobInfo).then(succFun).catch(failFun)
        },
        branding: false,
        elementpath: false,
        icons_url: `${baseURL}/icons/custom/icons.js`, // load icon pack
        icons: 'custom'      // baseURL/icons/custom/icons.js
      })
    })
  }
}
</script>